module.exports = __webpack_public_path__ + "img/relevadores_de_uso_general.76e692a6.jpg";